<template>
  <v-dialog class="import-se-dialog" :title="role == 1 ? 'Batch Operate' : 'Batch Add'" width="auto"
    :visible.sync="dialogVisible" :scrollbar="false" @closed="onClosed">
    <el-tabs type="card" v-model="tab">
      <el-tab-pane label="Batch Add" name="seAddList" v-if="role != 1"></el-tab-pane>
      <el-tab-pane label="Batch Transfer/Delete" name="seTransOrDelList" v-if="role == 1"></el-tab-pane>
    </el-tabs>
    <el-button class="export" type="primary" icon="iconfont icon-export" @click="exportButton">
      Export
    </el-button>
    <div>
      <el-table :data="tableData" :height="height" class="batch-add-table">
        <el-table-column label="No" width="80">
          <template slot-scope="{ $index }">
            <div>{{ $index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="seName" label="Name" width="80" />
        <el-table-column prop="province" label="Province" width="120" />
        <el-table-column prop="city" label="City" width="120" />
        <el-table-column prop="hospital" label="Hospital/Institution" min-width="200" />
        <el-table-column prop="department" label="Department" min-width="130" />
        <el-table-column prop="hcpId" label="HCPID" width="100" />
        <el-table-column prop="hcpType" label="Type" width="100" />
        <el-table-column label="User" prop="mslName" width="110">
        </el-table-column>
        <el-table-column prop="eaStatus" label="Source" width="100" v-if="tab === 'seAddList'">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.eaStatus"> eAuthorship</el-tag>
            <el-tag type="warning" v-else>CMDS</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="Status" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status ? 'success' : 'warning'">
              {{ row.statusName }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submitLoading" @click="submit"> Submit</el-button>
      <el-button @click="onClosed"> Cancel </el-button>
    </div>
  </v-dialog>
</template>
<script>
import { export_json_to_excel_new } from "@/utils/Export2Excel";

export default {
  name: "table-dialog",
  props: {},
  data() {
    return {
      tab: "",
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      tabData: {},
      submitLoading:false,
      excelHeader:[
        { header: 'Name', key: "seName" },
        { header: 'Province', key: "province" },
        { header: 'City', key: "city" },
        { header: 'Hospital/Institution', key: "hospital" },
        { header: 'Department', key: "department" },
        { header: 'HCPID', key: "hcpId" },
        { header: 'Type', key: "hcpType" },
        { header: 'User', key: "mslName" },
        { header: 'Status', key: "statusName" },
        { header: 'ErrorMessage', key: "checkMessage" },
      ],
      height: "334.44px",
    };
  },
  computed: {
    tableData() {
      return this.tabData?.[this.tab] ?? [];
    },
    role() {
      return this.$store.state.role;
    },
  },
  mounted() { },
  methods: {
    formatJson(headers, rows) {
      return rows.map((item) => {
        return Object.keys(headers).map((key) => {
          return item[headers[key]];
        });
      });
    },
    async exportButton() {
      const header = this.excelHeader
      const data = this.tableData
      const filename = this.tab == "seAddList"
            ? "Batch_Add_Result"
            : "Batch_Transfer/Delete_Result"
      await export_json_to_excel_new(header,data,filename)
    },
    open(data) {
      this.tabData = data;
      this.tab = this.role == 1 ? "seTransOrDelList" : "seAddList";
      this.dialogVisible = true;
    },
    submit() {
      const addList = Array.isArray(this.tabData.seAddList) ? this.tabData.seAddList : []
      const check = addList.filter(
        (item) => item.eaStatus && item.status
      );
      this.submitLoading = true
      if (check.length > 0) {
        this.$confirm(
          "Some of the data exists in eAuthorship ,if you confirm its should use EA data to create SE/CE. Or click cancel to check and add again?",
          {
            type: "warning",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          }
        ).then(() => {
          this.submitLoading = true
          this.axios
            .post("/se/saveImportSe", this.tabData)
            .then(({ code, msg }) => {
              this.submitLoading = false
              if (code === 200) {
                this.$message.success("Submit successfully");
                this.$emit("success");
                this.onClosed();
              } else {
                this.$message.error(msg);
              }
            });
        });
      } else {
        this.submitLoading = true
        this.axios
          .post("/se/saveImportSe", this.tabData)
          .then(({ code, msg }) => {
            this.submitLoading = false
            if (code === 200) {
              this.$message.success("Submit successfully");
              this.$emit("success");
              this.onClosed();
            } else {
              this.$message.error(msg);
            }
          });
      }
    },
    onClosed() {
      Object.assign(this.$data, this.$options.data());
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}

.export {
  position: absolute;
  top: 30px;
  right: 20px;
}

::v-deep {
  .el-tabs__item.is-active {
    color: $theme-color;
  }

  .el-tabs__item:hover {
    color: $theme-color;
  }

  .batch-add-table .el-table__body-wrapper {
    height: 298px !important;
  }
}
</style>
